

import { useEffect, useState } from "react";
import { sendOTP, voucherDownload } from "../../api";
import { Loader } from "../../../component/helper";
import { useProjectByStorage } from "../../projectData";
import { UserVirification } from "../../user-otp-verification";
/**
 * VocherOTPPopup component
 * Displays a popup for OTP verification before voucher download. Handles OTP sending, user verification, and download logic.
 * Shows loader, error messages, and manages popup visibility.
 */
const VocherOTPPopup = ({ redem_id, project_key, show, setShow, mobile, reload }) => {
    const project = useProjectByStorage();
    const [status, setStatus] = useState(null);
    const handleClose = () => setShow(false);
    useEffect(() => {
        const sendOtpRequest = async () => {
            if (mobile && project) {
                try {
                    const response = await sendOTP({
                        mobile: mobile,
                        project_key: project?.pkey,
                        type: 'redemption'
                    });

                    if (response.code === 1) {
                        setStatus('ok');
                    } else {
                        // Handle case where OTP sending failed
                        setStatus(response.message || 'Failed to send OTP');
                    }
                } catch (error) {
                    // Handle API error
                    setStatus(error?.response?.data?.message || 'An error occurred');
                }
            }
        };

        sendOtpRequest();
    }, [mobile, show, project]);


    const offcanvasStyles = {
        position: 'fixed',
        bottom: show ? '0' : '-100%', // Sliding from bottom
        left: '50%',
        transform: 'translateX(-50%)',
        width: '100%',
        maxWidth: '500px', // Limit width on larger screens
        height: '370px',
        backgroundColor: '#fff',
        borderRadius: '15px 15px 0 0',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
        transition: 'bottom 0.5s ease-in-out', // Slide up transition
        zIndex: 1050,
    };

    const overlayStyles = {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        opacity: show ? 1 : 0,
        visibility: show ? 'visible' : 'hidden',
        transition: 'opacity 0.3s ease-in-out',
        zIndex: 1040,
    };

    const submitRedemption = (value) => {
        voucherDownload({ redem_id: redem_id, project_key: project_key }).then((d) => {
            if (String(d.code) === '1') {
                reload()
                setShow(false)
            } else {
                setStatus(d.message || 'Failed to Download');
            }
        })

    }


    return (
        <div className="App">
            {/* Overlay */}
            <div style={overlayStyles} ></div>

            {/* Custom Offcanvas */}
            <div style={{ ...offcanvasStyles, }}> {/* Add marginBottom here */}
                <div className="card rounded-5"  >
                    <div className="card-body">

                        {status ? (
                            status !== 'ok' && (
                                <div className="mb-lg-15 alert alert-danger">
                                    <div className="alert-text font-weight-bold">{status}</div>
                                </div>
                            )
                        ) : (
                            <Loader />
                        )}
                        <div className="col-sm-12 mb-4">
                            {status === 'ok' &&
                                <UserVirification returnFunction={() => submitRedemption(1)} mobile={mobile} closePOup={() => handleClose()} />
                            }
                        </div>

                    </div>
                </div>
            </div>
        </div>

    );
};




export default VocherOTPPopup;
